import { Map } from 'immutable';

import * as constants from './../constants';

const initialState = Map({
  active: false,
  loading: false,
});

const mobileDevToolsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.MOBILE_DEV_TOOLS_SHOW: {
      return state.set('active', payload);
    }
    case constants.MOBILE_VITALS_SHOW:
    case constants.MOBILE_LOG_SHOW: {
      if (payload) {
        return state.set('active', false);
      }
      return state;
    }
    case constants.MOBILE_SESSION_STOP.SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default mobileDevToolsReducer;
export { initialState };
